// Go IM compatibility layer.
// Older modules expect a shared client object for current user lookup.
// Keep this file local-only: no third-party IM SDK import, no remote connection.

function readJson(key) {
    try {
        return JSON.parse(window.localStorage.getItem(key) || '{}')
    } catch (e) {
        return {}
    }
}

function currentUser() {
    const customUserInfo = readJson('customUserInfo')
    const loginUser = readJson('ZHWIM_loginUser')
    return (
        customUserInfo.hxusername ||
        customUserInfo.hxUserName ||
        loginUser.user ||
        ''
    )
}

function createMessage(options = {}) {
    return {
        ...options,
        id: options.id || `${Date.now()}${Math.floor(Math.random() * 10000)}`
    }
}

const noop = () => {}
const resolved = (value) => Promise.resolve(value)

const ImSDK = {
    logger: {
        disableAll: noop,
        setLevel: noop
    },
    message: {
        create: createMessage
    }
}

const ImClient = {
    get user() {
        return currentUser()
    },
    get version() {
        return 'go-im'
    },
    addEventHandler: noop,
    removeEventHandler: noop,
    open: () => resolved({ accessToken: readJson('ZHWIM_loginUser').accessToken || '' }),
    close: noop,
    isOpened: () => true,
    send: resolved,
    fetchUserInfoById: () => '',
    getServerToken: () => resolved({}),
    getConversationlist: () => resolved({ data: [] }),
    getHistoryMessages: () => resolved({ messages: [] }),
    recallMessage: resolved,
    destroyGroup: resolved,
    leaveGroup: resolved,
    getGroupInfo: () => resolved({ data: [] }),
    listGroupMember: () => resolved({ data: [] }),
    listGroups: () => resolved({ data: [] })
}

export { ImSDK, ImClient }
